var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import mixTraits from "../mixTraits";
import CatalogMemberReferenceTraits from "./CatalogMemberReferenceTraits";
import UrlTraits from "./UrlTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
let TerriaReferenceTraits = (_dec = traitClass({
  description: "Creates a catalog group or item from url that points to a terria catalog json file.\n  \n  <strong>Note:</strong> \n  <li>The referenced json file may contain more items than you need.</li>\n  <li>Specify required catalog entry IDs (e.g. \"LAEMW8fc\") in <code>path</code>. If not specified, the whole catalog will be added.</li>\n  <li>If the reference is a group, it is helpful to set <code>isGroup</code> to <code>true</code>.</li>",
  example: {
    type: "terria-reference",
    url: "https://tiles.terria.io/terriajs-examples/terria-reference/a-terria-catalog.json",
    isGroup: true,
    path: ["LAEMW8fc"],
    name: "terria-reference example",
    id: "some unique id for terria-reference example"
  }
}), _dec2 = primitiveTrait({
  name: "Is Open",
  description: "True if this group is open and its contents are visible; otherwise, false. (This only applies if `isGroup = true`)",
  type: "boolean"
}), _dec3 = primitiveArrayTrait({
  type: "string",
  name: "Path",
  description: "The path to the catalog item or group in the target catalog file given as a list of IDs. If not given, Terria will create a pseudo-group with all the catalog items in the catalog file as its members."
}), _dec(_class = (_class2 = class TerriaReferenceTraits extends mixTraits(UrlTraits, CatalogMemberReferenceTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
    _initializerDefineProperty(this, "path", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isOpen", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "path", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { TerriaReferenceTraits as default };